import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export class UninitializedBehaviorSubject<T> extends BehaviorSubject<T> {
  constructor(val: T = null) {
    super(val);
  }

  public asObservable(): Observable<T> {
    return super.asObservable().pipe(filter(o => !!o));
  }
}
